<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('emergency_contact_information') }}</h5>
        <b-row>
            <b-col cols="12" md="6">
                <b-card class="soft">
                    <template #header>
                        {{ $t('mother') }}: <strong>{{ getObjectValue(studentProgram, 'mother_name') }}</strong>
                    </template>
                    <div class="label-as-input-div">
                        <label>{{ $t('profession_job') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'mothers_job') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('education_status') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'mothers_education_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('contact_number') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'mothers_phone') }}
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" md="6">
                <b-card class="soft">
                    <template #header>
                        {{ $t('father') }}: <strong>{{ getObjectValue(studentProgram, 'father_name') }}</strong>
                    </template>
                    <div class="label-as-input-div">
                        <label>{{ $t('profession_job') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'fathers_job') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('education_status') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'fathers_education_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('contact_number') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'fathers_phone') }}
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_updatefamily') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal" size="xl"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_updatefamily') && editMode">
            <template v-slot:CommonModalTitle>
                {{ changeText($t('edit')) }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    /// Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

